import type { Dayjs } from "dayjs";

export const visibleDaySegment = (start: string | Date, end: string | Date, day: Dayjs) => {
  const startMs = new Date(start).getTime();
  const endMs = new Date(end).getTime();
  const dayStart = day.startOf("day").valueOf();
  const dayEnd = day.add(1, "day").startOf("day").valueOf();

  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs < startMs) return null;
  const exclusiveEnd = Math.max(endMs, startMs + 1);
  if (startMs >= dayEnd || exclusiveEnd <= dayStart) return null;

  return {
    start: new Date(Math.max(startMs, dayStart)),
    end: new Date(Math.min(exclusiveEnd, dayEnd)),
  };
};

export const timelineMinutes = (start: Date, end: Date) => {
  const startMinute = start.getHours() * 60 + start.getMinutes();
  const endMinute = end.toDateString() !== start.toDateString()
    ? 24 * 60
    : end.getHours() * 60 + end.getMinutes();
  return { startMinute, endMinute };
};
